import axios, {parseAxiosPromise} from '@/axiosInstance'
import {captureException} from '@sentry/react'
import {
    BugReportAttachmentRef,
    BugReportCommentList,
    BugReportIssueCreatePayload,
    BugReportIssueList,
    CreatedBugReportIssue
} from '../types'

/**
 * Backend proxy for the bug reporter. All calls go through the app's shared
 * authenticated axios instance (Bearer session token, refresh handling) — the
 * frontend no longer knows anything about the underlying issue tracker
 * (no API key, no team/project/assignee ids, no GraphQL endpoint).
 */

export const httpCreateBugReportIssue = (payload: BugReportIssueCreatePayload) =>
    parseAxiosPromise({
        axiosPromise: axios.post('bug-reporter/issues', payload),
        responseShape: CreatedBugReportIssue,
        onZodError: captureException
    })

export const httpUploadBugReportAttachment = (formData: FormData) =>
    parseAxiosPromise({
        axiosPromise: axios.post('bug-reporter/attachments', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }),
        responseShape: BugReportAttachmentRef,
        onZodError: captureException
    })

export const httpGetBugReportIssues = () =>
    parseAxiosPromise({
        axiosPromise: axios.get('bug-reporter/issues'),
        responseShape: BugReportIssueList,
        onZodError: captureException
    })

export const httpGetBugReportIssueComments = (issueId: string) =>
    parseAxiosPromise({
        axiosPromise: axios.get(`bug-reporter/issues/${issueId}/comments`),
        responseShape: BugReportCommentList,
        onZodError: captureException
    })
